var translations = {
    de: {
        salutation: 'Anrede',
        salutationMale: 'Herr',
        salutationFemale: 'Frau',
        firstName: 'Vorname',
        firstNameDescription: 'Um die Gültigkeit der Angebote gewährleisten zu können, geben Sie bitte Ihren Vornamen so an, wie er in Ihrem Pass und/oder Ausweis steht.',
        surname: 'Nachname',
        surnameDescription: 'Um die Gültigkeit der Angebote gewährleisten zu können, geben Sie bitte Ihren Nachnamen so an, wie er in Ihrem Pass und/oder Ausweis steht.',
        dateOfBirth: 'Geburtsdatum',
        email: 'E-Mail',
        emailDescription: "Ein Teil unserer Kommunikation verl\u00E4uft per E-Mail. Ihr pers\u00F6nlicher Spezialist f\u00FCr Bau-/Immobilienfinanzierung wird\nIhnen unverbindliche Angebote und Unterlagen zusenden.",
        phone: 'Telefon',
        phoneDescription: 'Ihr persönlicher Spezialist für Bau-/Immobilienfinanzierung hilft Ihnen gerne telefonisch beim Ausfüllen der Daten, Vergleich der Angebote sowie der Beantwortung Ihrer Fragen.',
        phonePlaceholder: '0170 12345678',
    },
};
export default translations;
